import { createStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    closeButton: {
      position: 'absolute',
      right: '10px',
      top: '5px',
      width: '30px',
      height: '30px',
      background: '#FFFFFF',
      border: '1px solid #2C2D3ECC',
      borderRadius: '3px',
      fontSize: 'small',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    xInButton: {
      position: 'relative',
      top: '2px',
      color: '#2C2D3ECC',
    },
  }),
);
